import React from "react";
import CardCarousel from "./CardCarousel";
import CardCarouselMobile from "./CardCarouselMobile";
export default function Highlights() {

  return (
    <div id="highlights">
      <section className="bg-[#fff] py-10 xl:py-14 xl:px-[50px] overflow-hidden shape">
        <div className="max-w-screen-xl mx-auto lg:px-6 text-center ">
          <h2 className="font-crimson text-3xl xl:text-5xl pb-10 text-[#5e3920]">
           Sustainable Living in Apartments Near Patancheru

          </h2>
          <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 px-4 xl:text-[18px] font-inter leading-relaxed">
           Aura incorporates sustainability-focused features intended to support efficient resource use, comfortable indoor environments and responsible community living
          </p>
          {/* Show only on large screens */}
          <div className="hidden lg:block">
            <CardCarousel />
          </div>

          {/* Show only on mobile & tablet */}
          <div className="block lg:hidden">
            <CardCarouselMobile />
          </div>
        </div>
       
      </section>
    </div>
  );
}
